import styled from 'styled-components';

import HTMLContent from '@telialt/common-html-content/src';

export const ProductOverviewTitle = styled.h3`
    font-size: 1.875rem;
    font-weight: 700;
`;

export const ProductDescription = styled(HTMLContent)`
    margin: 2.5rem 0;
`;
